// /**
//  * Warwhouse - Add
//  */

// React
import React, { useState, useContext, useEffect } from 'react';
// Context
import AuthContext from '../../../authContext';

// react hook form
import { Controller, useForm } from 'react-hook-form';

// UI
import theme from '../../..//theme';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import {
    TextField,
    Grid,
    Button,
    CircularProgress,
    Paper,
    Typography,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    DialogContent,
    IconButton,
    DialogActions,
    Dialog,
    FormHelperText,
    DialogTitle,
    Divider,
} from '@material-ui/core';
import Modal from '../../..//components/Modal';
import AddItemsParcelsList from './addItemsParcelsList';
import AddItemsParcelsForm from './addItemsParcelsForm';
import AddItemsWarehouseParcelsForm from './addItemsWarhouseParcelsForm';
import InventoryItemsList from './inventoryItemsList';
import jMoment from 'moment-jalaali';
import Autocomplete from '@material-ui/lab/Autocomplete';
// Icon
import Icon from '@mdi/react';
import {
    mdiPackageVariantClosed,
    mdiArrowRight,
    mdiAccountOutline,
    mdiClose,
    mdiCheck,
    mdiCubeSend,
    mdiCubeOutline,
    mdiCounter,
    mdiTableRowHeight,
    mdiTableColumnWidth,
    mdiRuler,
    mdiBarcodeScan,
    mdiPackageVariant,
    mdiInformation,
    mdiCartPlus,
    mdiWarehouse
} from '@mdi/js';

// Client SDK
import Client from 'client-sdk/src/client';
import { GetAllWarehousesRequestBuilder } from 'client-sdk/src/warehouses/warehouses';

// Type
import { ParcelItems, PayloadCreate } from '../interfaces';
import {
    AddItemCreateParcel,
    AddInventoryItemCreateParcel,
} from '../../parcels/interfaces';

// helpers'
import {
    flattenObject,
    removeEmptyValueObject,
    convertPersianDigit2English,
} from '../../../utils/helpers';
import { useHistory } from 'react-router-dom';
import ListDimensions from '../../..//pages/orderPack/dimensionsList';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import handleNotfication from '../../../utils/handleNotification';
import handleError from '../../..//utils/handleError';
import parcelRepository from 'client-sdk/src/Repository/parcels-repository';
import partnerRepository from 'client-sdk/src/Repository/partners-repository';
import centerRepository from 'client-sdk/src/Repository/centers-repository';
import warehouseRepository from 'client-sdk/src/Repository/warehouses-repository';

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

type Props = {
    create: (body: any) => void;
    onClose: () => void;
    warehouseId: number;
    createParcelsDispatch: (payload: PayloadCreate) => void;
};

type Inputs = {
    agentName: string;
    agentPhoneNumber: string;
    receiptTitle: string;
    deliveryDate: string;
    pickAddress: string;
    pickDate: string;
    pickTime: string;
    deliveryTime: string;
    destinationId: number;
    deliveryType: string;
    id: number;
    items: ParcelItems[];
    deliveryStartTime: string;
    deliveryEndTime: string;
    sourceId: number;
    status: string;
    sourceWarehouseName: string;
    destinationWarehouseName: string;
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        paper: {
            marginTop: '36px',
            marginBottom: '36px',
            marginLeft: '20px',
            marginRight: '20px',
            width: '100%',
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            border: '1px solid #ddd',
            borderRadius: '4px',
            '@media (max-width: 768px)': {
                padding: theme.spacing(0),
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(3),
                backgroundColor: theme.palette.background.default,
            },
        },
        // Cancel Dialog
        cancelIcon: {
            textAlign: 'center',
            position: 'relative',
            paddingLeft: theme.spacing(8),
            marginBottom: theme.spacing(7),

            '&::before': {
                content: '""',
                position: 'absolute',
                width: '100px',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                height: '100px',
                borderRadius: '50%',
                opacity: '0.2',
                backgroundColor: theme.palette.success.main,
            },
        },
        cancelTitle: {
            fontSize: '16px',
            fontWeight: 500,
            textAlign: 'center',
            lineHeight: 2,
            marginBottom: theme.spacing(3),
        },
        actionsBox: {
            paddingTop: theme.spacing(2),
            paddingRight: theme.spacing(3),
            paddingLeft: theme.spacing(3),
        },
        headerBox: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '28px',
        },
        addProductsButtons: {
            marginLeft: 0,
            marginRight: 0,
            marginBottom: '40px',
            padding: '0 20px',
        },
        addProduct: {},
        margin: {
            // margin: theme.spacing(1),
        },
        withoutLabel: {
            marginTop: theme.spacing(3),
        },
        textInput: {
            // width: '25ch',
            '& input, .MuiSelect-root': {
                padding: '6px 0 12px !important',
            },

            '& .MuiInput-underline::before': {
                borderBottom: '1px solid #d8d8d8 !important',
            },
        },

        item: {
            display: 'flex',
            alignSelf: 'center',
            alignItems: 'center',
            fontWeight: 500,
            width: '100%',
            '& > *': {
                // margin: theme.spacing(0, 0, 0, 1),
            },
        },
        icon: {
            color: '#8a8a8a',
            marginRight: theme.spacing(1),
        },
        label: {
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
            fontWeight: 400,
            color: '#8a8a8a',
            marginRight: '8px',
            marginTop: '21px',
        },
        detail: {
            backgroundColor: 'white',
            width: '100%',
        },
        editIcon: {
            textAlign: 'center',
            position: 'relative',
            marginBottom: theme.spacing(7),
            '&::before': {
                content: '""',
                position: 'absolute',
                width: '100px',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                height: '100px',
                borderRadius: '50%',
                opacity: '0.2',
                backgroundColor: theme.palette.blue.main,
            },
        },
        addIcon: {
            textAlign: 'center',
            position: 'relative',
            paddingLeft: theme.spacing(8),
            // marginBottom: theme.spacing(7),
            '&::before': {
                content: '""',
                position: 'absolute',
                width: '100px',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                height: '100px',
                borderRadius: '50%',
                opacity: '0.2',
                backgroundColor: theme.palette.green.main,
            },
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    })
);

function Add(props: Props) {
    const classes = useStyles();
    const authContext = useContext(AuthContext);
    const history = useHistory();
    const { register, handleSubmit, errors, watch, setValue, getValues } =
        useForm<Inputs>({
            defaultValues: {
                deliveryType: '',
                deliveryTime: '',
                deliveryDate: null,
                pickDate: null,
                pickTime: null,
                deliveryStartTime: null,
                deliveryEndTime: null,
                partner: null,
            },
        });

    const [items, setItems] = useState<any>([]);
    const [transportationType, setTransportationType] = useState<any>('');
    const [itemDeleted, setItemDeleted] = useState<any>({});
    const [serialNumber, setSerialNumber] = useState<any>('');
    const [oldInventoryItemWithSerial, setOldInventoryItemWithSerial] =
        useState<any>('');

    const [itemsInfo, setItemsInfo] = useState<any>([]);
    const [partnersLoading, setPartnersLoading] = useState<boolean>(false);
    const [partners, setPartners] = useState<any>([]);
    const [openAddItem, setOpenAddItem] = useState(false);
    const [openAddWarehouseItem, setOpenAddWarehouseItem] = useState(false);
    const [openItemHasAlreadyAdded, setOpenItemHasAlreadyAdded] = useState(
        false as boolean
    );
    const [openInventoryItemsList, setOpenInventoryItemsList] = useState(false);
    const [hasInventoryItemsList, setHasInventoryItemsList] = useState(false);
    const [inventoryItemsWithFilter, setInventoryItemsWithFilter] = useState([]);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
    const [checkSubmit, setCheckSubmit] = React.useState(false as boolean);
    const [parcelsData, setParcelsData] = React.useState({});
    const [options, setOptions] = React.useState<any[]>([]);
    const [openDimensions, setOpenDimensions] = useState(false as boolean);
    const [openListDimensions, setOpenListDimensions] = useState(
        false as boolean
    );
    const [dimensions, setDimensions] = useState<any>([]);
    const [boxCount, setBoxCount] = useState('');
    const [totalBoxCount, setTotalBoxCount] = useState(0);
    const [count, setCount] = useState('');
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [unitCode, setUnitCode] = useState('');
    const [partner, setPartner] = useState([]);
    const [submitModal, setSubmitModal] = useState(false);
    const [submitData, setSubmitData] = useState([]);
    const loading = openAutocomplete && options.length === 0;

    useEffect(() => {
        let active = true;
        if (!loading) {
            return undefined;
        }

        (async () => {
            const token = localStorage.getItem('token') || '';
            const makeRequest = new GetAllWarehousesRequestBuilder()
                .params({
                    'status.equals': 'ACTIVE',
                    size: 100,
                })
                .build();
            const client = new Client(token);
            const response = await client.execute(makeRequest);
            const warehouses = response.data as any;
            if (active) {
                setOptions(warehouses as any[]);
            }
        })();

        return () => {
            active = false;
        };
    }, [loading]);

    useEffect(() => {
        if (!openAutocomplete) {
            setOptions([]);
        }
    }, [openAutocomplete]);

    const addDimensions = () => {
        const newDimension = {
            count,
            length,
            width,
            height,
        };
        setDimensions([...dimensions, newDimension]);
        setCount('');
        setLength('');
        setHeight('');
        setWidth('');
    };

    useEffect(() => {
        let totalCount: any = 0;
        dimensions.forEach((dimension: any) => {
            totalCount += Number(dimension.count);
        });
        setTotalBoxCount(totalCount);
    }, [dimensions]);

    const checkButtonDisabled = () => {
        const fields = [count, length, width, height];
        return fields.some(field => !field) && totalBoxCount < Number(boxCount);
    };

    const handleCloseDimensions = () => {
        setOpenDimensions(false);
        setBoxCount('');
        setOpenListDimensions(false);
        setDimensions([]);
    };

    const setUpdateStatus = () => {
        setCheckSubmit(true);
    };

    const setParcelItems = () => {
        const inventoryItemsSortedByVariantId = itemsInfo.sort(function (a, b) {
            return a.variantId - b.variantId;
        });

        const parcelVariants: any[] = [];
        const parcelItems: any[] = [];
        let parcelItem = {} as any;

        inventoryItemsSortedByVariantId.forEach((item: any) => {
            if (!parcelVariants.includes(item.variantId)) {
                parcelItem = {};
                parcelVariants.push(item.variantId);
                parcelItem = {
                    variantId: item.variantId,
                    productId: item.productId,
                    count: 1,
                    packageCount: 1,
                    packageAmount: 1 ?? Number(count),
                    inventoryItemIds: [item.id],
                };
                parcelItems.push(parcelItem);
            } else {
                parcelItem.inventoryItemIds.push(item.id);
            }
        });
        setItems(parcelItems);
        return parcelItems;
    };
    const onSubmitFormHandler = () => {
        const { receiptTitle } = submitData;
        const parcelItems = setParcelItems();
        const unitBarcode = unitCode;
        addParcel({
            items: parcelItems,
            receiptTitle,
            // deliveryDate,
            unitBarcode,
            type: transportationType,
            sourceId: authContext.user.warehouseId,
            transportationType: 'RONAD',
            partnerId: partner.id,
            destinationId : authContext.user.warehouseId,
            // deliveryStartTime: convertPersianDigit2English(
            // ),
        });
    }
    const onSubmit = (data: Inputs) => {
        setSubmitModal(true);
        setSubmitData(data);

    };

    const addParcel = (body: any) => {
        setParcelsData(body);
        handleOpenCheckConfirm();
    };

    const getPartners = async (actions: any) => {
        const payload = { ...actions };

        try {
            setPartnersLoading(true);
            const { response, count } = await partnerRepository.getPartners({ payload });
            setPartners([
                ...response.data.map((partner: any) => {
                    return {
                        id: partner.id,
                        name: partner.name,
                    };
                }),
            ]);
        } catch (error) {
            handleNotfication(error.message, 'error');
        } finally {
            setPartnersLoading(false);
        }
    };

    const getWarehouses = async (actions: any) => {
        const payload = { ...actions };

        try {
            const { response } = await warehouseRepository.getWarehouses({ payload });
        } catch (error) {
            handleNotfication(error.message, 'error');
        }
    };

    useEffect(() => {
        getPartners({size: 500});
        getWarehouses({ 'status.equals': 'ACTIVE', size: 100 });
    }, []);

    const createParcels = async (actions: any) => {
        const payload = { ...actions };
        try {
            const { pagination, callback, id } =
                await parcelRepository.createParcelOtherType({
                    payload,
                });
            handleNotfication('محموله با موفقیت اضافه شد', 'success');
            callback && callback();
        } catch (error) {
            handleNotfication('اضافه کردن محصول با خطا مواجه شد', 'error');
            handleError(error.response);
        }
    };

    const handleAddItem = (item: any) => {
        setItemsList(item);
        const newValue = inventoryItemsWithFilter.filter(
            (itemValue: any) => item.id !== itemValue.id
        );
        setInventoryItemsWithFilter(newValue);
    };

    const addToItems = () => {
        const inventoryItemsMap = inventoryItemsWithFilter.map(
            (inventoryItem: any) => {
                const {
                    id,
                    partnerName,
                    status,
                    sellerName,
                    providerName,
                    serialNumber,
                    productName,
                    productCode,
                    variantCode,
                    variantId,
                    productId,
                } = inventoryItem;
                return {
                    id,
                    partnerName,
                    status,
                    sellerName,
                    providerName,
                    serialNumber,
                    productName,
                    productCode,
                    variantCode,
                    variantId,
                    productId,
                };
            }
        );
        setItemsInfo([...itemsInfo, ...inventoryItemsMap]);
        setOpenInventoryItemsList(false);
        setOpenAddItem(false);
    };

    const setConfirmDelete = (body: any) => {
        setOpenConfirmDelete(true);
        setItemDeleted(body);
    };

    const handleOpenCheckConfirm = () => {
        setCheckSubmit(true);
    };

    const handleCloseCheckConfirm = () => {
        setCheckSubmit(false);
    };

    const handleClose = () => {
        setOpenConfirmDelete(false);
        setSubmitModal(false)
    };

    const deleteItemsToParcels = () => {
        const newValue = items.filter((item: any) => item.id !== itemDeleted.id);
        const newValueInfo = itemsInfo.filter(
            (item: any) => item.id !== itemDeleted.id
        );

        setItems(newValue);
        setItemsInfo(newValueInfo);
        setOpenAddItem(false);
        handleClose();
    };

    const handleCreateParcel = () => {
        const parcelData = { ...parcelsData };
        createParcels({
            body: parcelData,
            pagination: {
                sourceWarehouseId: { equals: authContext.user?.warehouseId },
            },
            callback: () => {
                setParcelsData({});
                history.push('/parcels-sender');
            },
        });
        handleCloseDimensions();
        setCheckSubmit(false);
    };

    const getInventoryItemsWithSerialAction = async (
        action: any,
        callbackFunc: any
    ) => {
        const payload = { ...action };
        try {
            const { response, callback } =
                await inventoryItemsRepository.getInventoryItemsWithSerial(
                    { payload },
                    callbackFunc
                );
            setItemsList(response.data.content[0]);
            response.data.content.length !== 0 && callback && callback();
            if (response.data.content.length === 0)
                handleNotfication('هیچ آیتمی پیدا نشد.', 'warn');
        } catch (error) {
            handleError(error.response);
        }
    };

    const getInventoryItemsAction = async (action: any, callbackFunc: any) => {
        const payload = { ...action };
        try {
            const { response, callback } =
                await inventoryItemsRepository.getInventoryItemsWithSerial(
                    { payload },
                    callbackFunc
                );
            setInventoryItemsWithFilter(response.data.content);
            response.data.content.length !== 0 && callback && callback();
            if (response.data.content.length === 0)
                handleNotfication('هیچ آیتمی پیدا نشد.', 'warn');
        } catch (error) {
            handleError(error.response);
        }
    };

    const handleGetInventoryItems = (filters: any) => {
        getInventoryItemsAction(
            {
                ...filters,
            },
            () => setOpenInventoryItemsList(true)
        );
    };

    const handleGetWarehouseInventoryItems = (filters: any) => {
        setHasInventoryItemsList(false);
        getInventoryItemsAction(
            {
                ...filters,
            },
            () => {
                setOpenAddWarehouseItem(false);
                setHasInventoryItemsList(true);
            }
        );
    };

    useEffect(() => {
        if (inventoryItemsWithFilter.length && hasInventoryItemsList) {
            setItemsInfo([...itemsInfo, ...inventoryItemsWithFilter]);
        }
    }, [hasInventoryItemsList, inventoryItemsWithFilter]);

    const handleCloseItemHasAlreadyAdded = () => {
        setOpenItemHasAlreadyAdded(false);
        setSerialNumber('');
    };

    const setItemsList = (data: any) => {
        if (!data) return;
        const oldInventoryItem = itemsInfo.filter(
            (item: any) => data.serialNumber === item.serialNumber
        );
        if (oldInventoryItem.length !== 0) {
            setOldInventoryItemWithSerial(oldInventoryItem[0].serialNumber);
            setOpenItemHasAlreadyAdded(true);
            return;
        }

        const {
            id,
            partnerName,
            status,
            sellerName,
            providerName,
            serialNumber,
            productName,
            productCode,
            variantCode,
            variantId,
            productId,
        } = data;
        setItemsInfo([
            ...itemsInfo,
            {
                id,
                partnerName,
                status,
                sellerName,
                providerName,
                serialNumber,
                productName,
                productCode,
                variantCode,
                variantId,
                productId,
            },
        ]);
    };

    const getInventoryItemsWithSerial = (serial: string) => {
        getInventoryItemsWithSerialAction(
            {
                serialNumber: { equals: serial },
            },
            () => setSerialNumber('')
        );
    };

    const values = getValues();

    return (
        <>
            <div className={classes.headerBox}>
                <Typography variant="h6" component="h2">
                    {`
        ایجاد قبض
        `}
                </Typography>
            </div>

            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
            >
                <Button
                    aria-label="details"
                    size="medium"
                    onClick={() => window.history.back()}
                >
                    <Icon path={mdiArrowRight} size={1} className={classes.icon} />
                    {'بازگشت'}
                </Button>
            </Grid>
            <form style={{ display: 'flex' }} onSubmit={handleSubmit(onSubmit)}>
                <Grid
                    container
                    style={{ margin: '30px 0', width: '100%' }}
                    spacing={5}
                    alignItems="flex-start"
                >
                    <Grid item container justify="flex-end" xs={12}>
                        <Button
                            type="submit"
                            size="large"
                            data-cy="search"
                            autoFocus
                            variant="contained"
                            color="primary"
                            disabled={
                                Object.keys(flattenObject(removeEmptyValueObject({ ...watch() })))
                                    .length === 0
                            }
                        >
                            {'ایجاد قبض'}
                        </Button>
                    </Grid>
                    <Paper
                        elevation={3}
                        className={classes.paper}
                        variant="elevation"
                        square
                    >
                        <div style={{ marginTop: '-66px' }} className={classes.addIcon}>
                            <Icon
                                path={mdiPackageVariantClosed}
                                size={4}
                                color={theme.palette.green.main}
                            />
                        </div>
                        <Grid
                            style={{ padding: '20px' }}
                            container
                            spacing={5}
                            alignItems="flex-start"
                        >
                            <Grid container item xs={6} sm={3} alignItems="flex-end">
                                <div className={classes.item}>
                                    <span className={classes.label}>
                                        <Icon
                                            path={mdiCubeSend}
                                            size={1}
                                            className={classes.icon}
                                        />
                                    </span>

                                    <span style={{ width: '100%' }}>
                                        <FormControl style={{ width: '100%' }}>
                                            <InputLabel id="transportationTypeLabel">
                                                نوع قبض
                                            </InputLabel>
                                            <Select
                                                fullWidth
                                                id="transportationType"
                                                name="transportationType"
                                                inputProps={{
                                                    name: 'transportationType',
                                                    id: 'transportationType',
                                                }}
                                                labelId="transportationTypeLabel"
                                                value={transportationType}
                                                onChange={e => setTransportationType(e.target.value)}
                                                className={classes.textInput}
                                                inputRef={register({ required: true })}
                                            >
                                                <MenuItem value={'RECEIPT_TO_WASTAGE'}>ورود به قرنطینه</MenuItem>
                                                <MenuItem value={'RECEIPT_FROM_WASTAGE'}>خروج از قرنطینه</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </span>
                                </div>
                            </Grid>{' '}
                            <Grid container item xs={12} sm={9} alignItems="flex-end">
                                <div className={classes.item}>
                                    <span className={classes.label}>
                                        <Icon
                                            path={mdiAccountOutline}
                                            size={1}
                                            className={classes.icon}
                                        />
                                    </span>

                                    <div style={{ width: '100%' }}>
                                        <TextField
                                            fullWidth
                                            id="receiptTitle"
                                            name="receiptTitle"
                                            label="عنوان قبض"
                                            className={classes.textInput}
                                            inputRef={register({
                                                required: transportationType === 'RECEIPT',
                                            })}
                                            error={errors.receiptTitle && true}
                                        />
                                    </div>
                                </div>
                            </Grid>


                            <Grid container item xs={12} sm={3} alignItems="flex-end">
                                <div className={classes.item}>
                                    <span className={classes.label}>
                                        <Icon
                                            path={mdiWarehouse}
                                            size={1}
                                            className={classes.icon}
                                        />
                                    </span>

                                    <span
                                        style={{
                                            width: '100%',
                                            marginTop: '16px',
                                            marginBottom: '8px',
                                        }}
                                    >


                                        <Autocomplete
                                            getOptionSelected={(option, value) =>
                                                option.name === value?.name
                                            }
                                            getOptionLabel={option => option.name}
                                            options={partners}
                                            value={partner}
                                            loading={partnersLoading}
                                            onChange={(event: any, newValue: any) => {
                                                setPartner(newValue);
                                            }}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    label="نام شرکت"
                                                    name="partner"
                                                    id="partner"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {partnersLoading ? (
                                                                    <CircularProgress
                                                                        color="inherit"
                                                                        size={20}
                                                                    />
                                                                ) : null}
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />

                                        <FormHelperText error focused>
                                            {errors?.partner &&
                                                'نام شرکت الزامی میباشد'}
                                        </FormHelperText>
                                    </span>
                                </div>
                            </Grid>
                        </Grid>
                    </Paper>

                </Grid>
            </form>

            <Grid
                className={classes.addProductsButtons}
                container
                item
                justify="flex-end"
                xs={12}
            >
                <BarcodeForm
                    handleSubmitForm={(serial: string) =>
                        getInventoryItemsWithSerial(serial)
                    }
                    serialNumber={serialNumber}
                    setSerialNumber={(value: string) => setSerialNumber(value)}
                    cssClasses={classes}
                />
            </Grid>
            <Grid
                className={classes.addProductsButtons}
                container
                item
                xs={12}
                alignItems="flex-end"
            >
                {itemsInfo.length > 0 && (
                    <div
                        style={{
                            margin: '0 10px 20px 0',
                            fontWeight: 'bold',
                            fontSize: '16px',
                        }}
                    >
                        <span>{'تعداد : '}</span>
                        {itemsInfo.length}
                    </div>
                )}
                <div className={classes.item}>
                    {itemsInfo.length > 0 && (
                        <AddItemsParcelsList
                            data={itemsInfo}
                            deleteItem={(body: any) => setConfirmDelete(body)}
                        />
                    )}
                </div>
            </Grid>

            <Dialog
                open={openConfirmDelete}
                fullWidth
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <div
                        style={{
                            position: 'absolute',
                            left: '17px',
                            zIndex: 10,
                        }}
                    >
                        {handleClose ? (
                            <IconButton
                                aria-label="close"
                                // className={classes.closeButton}
                                onClick={handleClose}
                            >
                                <Icon path={mdiClose} size={1} />
                            </IconButton>
                        ) : null}
                    </div>
                    <div className={classes.cancelIcon}>
                        <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
                    </div>
                    <div
                        className={classes.cancelTitle}
                    >{`از حذف آیتم انبار با سریال ${itemDeleted.serialNumber} مطمئن هستید؟`}</div>
                </DialogContent>
                <DialogActions className={classes.actionsBox}>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <Button
                                fullWidth
                                autoFocus
                                onClick={handleClose}
                                variant="contained"
                                color="secondary"
                                size="large"
                            >
                                {'خیر'}
                            </Button>
                        </Grid>
                        <Grid item xs={4}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={deleteItemsToParcels}
                                size="large"
                            >
                                {'بله'}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <Dialog
                open={submitModal}
                fullWidth
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <div
                        style={{
                            position: 'absolute',
                            left: '17px',
                            zIndex: 10,
                        }}
                    >
                        {handleClose ? (
                            <IconButton
                                aria-label="close"
                                // className={classes.closeButton}
                                onClick={handleClose}
                            >
                                <Icon path={mdiClose} size={1} />
                            </IconButton>
                        ) : null}
                    </div>
                    {/* <div className={classes.cancelIcon}>
                        <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
                    </div> */}
                    <div
                        className={classes.cancelTitle}
                    >{'سریال یونیت مورد نظر را اسکن کنید'}</div>
                    <Grid container item xs={12} sm={12} alignItems="flex-end">
                        <div className={classes.item}>
                            <span className={classes.label}>
                                <Icon path={mdiBarcodeScan} size={1} color="black" />
                            </span>

                            <div style={{ width: '100%' }}>
                                <TextField
                                    fullWidth
                                    id="unitcode"
                                    name="unitcode"
                                    label="سریال"
                                    className={classes.textInput}
                                    // inputRef={register({
                                    //     required: transportationType === 'RECEIPT',
                                    // })}
                                    onChange={(e) => { setUnitCode(e.target.value) }}
                                // error={errors.receiptTitle && true}
                                />
                            </div>
                        </div>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.actionsBox}>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <Button
                                fullWidth
                                autoFocus
                                onClick={handleClose}
                                variant="contained"
                                size="small"
                            >
                                {'انصراف'}
                            </Button>
                        </Grid>
                        <Grid item xs={4}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={onSubmitFormHandler}
                                size="small"
                            >
                                {'تایید'}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            <Dialog
                open={checkSubmit}
                fullWidth
                onClose={handleCloseCheckConfirm}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <div
                        style={{
                            position: 'absolute',
                            left: '17px',
                            zIndex: 10,
                        }}
                    >
                        {handleCloseCheckConfirm ? (
                            <IconButton aria-label="close" onClick={handleCloseCheckConfirm}>
                                <Icon path={mdiClose} size={1} />
                            </IconButton>
                        ) : null}
                    </div>
                    <div className={classes.cancelIcon}>
                        <Icon path={mdiCheck} size={4} color={theme.palette.success.main} />
                    </div>
                    <div className={classes.cancelTitle}>
                        {
                            `ایا از ایجاد قبض خروج با عنوان "${values.receiptTitle}" مطمئنید؟`}
                    </div>
                </DialogContent>
                <Divider />
                <DialogActions className={classes.actionsBox}>
                    <Grid container spacing={2} justifyContent="flex-end">
                        <Grid item xs={2}>
                            <Button
                                fullWidth
                                autoFocus
                                onClick={handleCloseCheckConfirm}
                                variant="outlined"
                                size="large"
                            >
                                {'انصراف'}
                            </Button>
                        </Grid>
                        <Grid item xs={5}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={handleCreateParcel}
                                size="large"
                                color="primary"
                            >
                                {transportationType === 'RECEIPT'
                                    ? `ایجاد قبض خروج`
                                    : transportationType === 'WAREHOUSE'
                                        ? `ایجاد محموله بین انبار`
                                        : `ایجاد محموله خروجی شرکت`}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <Dialog
                fullWidth
                open={openDimensions}
                onClose={handleCloseDimensions}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <div
                        style={{
                            position: 'absolute',
                            left: '17px',
                            zIndex: 10,
                        }}
                    >
                        {handleCloseDimensions ? (
                            <IconButton
                                aria-label="close"
                                // className={classes.closeButton}
                                onClick={handleCloseDimensions}
                            >
                                <Icon path={mdiClose} size={1} />
                            </IconButton>
                        ) : null}
                    </div>
                    <div className={classes.addIcon}>
                        <Icon path={mdiCubeOutline} size={4} color="#039590" />
                    </div>
                    {boxCount && openListDimensions ? (
                        <Grid container alignItems="center" spacing={4}>
                            <Grid
                                container
                                item
                                xs={12}
                                sm={6}
                                spacing={1}
                                alignItems="flex-end"
                            >
                                <Grid item xs={2}>
                                    <Icon path={mdiCounter} size={1} />
                                </Grid>
                                <Grid item xs={10}>
                                    <TextField
                                        fullWidth
                                        id="count"
                                        name="count"
                                        value={count}
                                        onChange={e => setCount(e.target.value)}
                                        label="تعداد"
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                item
                                xs={12}
                                sm={6}
                                spacing={1}
                                alignItems="flex-end"
                            >
                                <Grid item xs={2}>
                                    <Icon path={mdiTableRowHeight} size={1} />
                                </Grid>
                                <Grid item xs={10}>
                                    <TextField
                                        fullWidth
                                        id="length"
                                        name="length"
                                        value={length}
                                        onChange={e => setLength(e.target.value)}
                                        label="طول"
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                item
                                xs={12}
                                sm={6}
                                spacing={1}
                                alignItems="flex-end"
                            >
                                <Grid item xs={2}>
                                    <Icon path={mdiTableColumnWidth} size={1} />
                                </Grid>
                                <Grid item xs={10}>
                                    <TextField
                                        fullWidth
                                        id="width"
                                        name="width"
                                        value={width}
                                        onChange={e => setWidth(e.target.value)}
                                        label="عرض"
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                item
                                xs={12}
                                sm={6}
                                spacing={1}
                                alignItems="flex-end"
                            >
                                <Grid item xs={2}>
                                    <Icon path={mdiRuler} size={1} />
                                </Grid>
                                <Grid item xs={10}>
                                    <TextField
                                        fullWidth
                                        id="height"
                                        name="height"
                                        value={height}
                                        onChange={e => setHeight(e.target.value)}
                                        label="ارتفاع"
                                    />
                                </Grid>
                            </Grid>
                            {dimensions.length !== 0 && (
                                <Grid item xs={12}>
                                    <ListDimensions data={dimensions} modal />
                                </Grid>
                            )}
                        </Grid>
                    ) : (
                        <Grid container spacing={1} alignItems="flex-end">
                            <Grid item xs={12}>
                                <p>{'تعداد بسته بندی های محموله را وارد کنید'}</p>
                            </Grid>
                            <Grid item xs={1}>
                                <Icon path={mdiCounter} size={1} />
                            </Grid>
                            <Grid item xs={11}>
                                <TextField
                                    fullWidth
                                    id="boxCount"
                                    name="boxCount"
                                    value={boxCount}
                                    onChange={e => setBoxCount(e.target.value)}
                                    label="تعداد بسته"
                                />
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions className={classes.actionsBox}>
                    {boxCount && openListDimensions ? (
                        <Grid container spacing={2}>
                            <Grid item xs={8}>
                                <Button
                                    fullWidth
                                    autoFocus
                                    onClick={
                                        totalBoxCount < Number(boxCount)
                                            ? addDimensions
                                            : setUpdateStatus
                                    }
                                    variant="contained"
                                    color="secondary"
                                    disabled={checkButtonDisabled()}
                                    size="large"
                                >
                                    {totalBoxCount >= Number(boxCount)
                                        ? 'مرحله بعد'
                                        : 'اضافه کردن بسته'}
                                </Button>
                            </Grid>
                            <Grid item xs={4}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    size="large"
                                >
                                    {'بازگشت'}
                                </Button>
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid container spacing={2}>
                            <Grid item xs={8}>
                                <Button
                                    fullWidth
                                    autoFocus
                                    onClick={() => setOpenListDimensions(true)}
                                    variant="contained"
                                    color="secondary"
                                    disabled={!boxCount}
                                    size="large"
                                >
                                    {'مرحله بعد'}
                                </Button>
                            </Grid>
                            <Grid item xs={4}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => handleCloseDimensions()}
                                    size="large"
                                >
                                    {'بستن'}
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </DialogActions>
            </Dialog>

            <Dialog
                fullWidth
                open={openItemHasAlreadyAdded}
                onClose={handleCloseItemHasAlreadyAdded}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle>
                    <div
                        style={{
                            position: 'absolute',
                            left: '17px',
                            zIndex: 10,
                        }}
                    >
                        {handleCloseItemHasAlreadyAdded ? (
                            <IconButton
                                aria-label="close"
                                // className={classes.closeButton}
                                onClick={handleCloseItemHasAlreadyAdded}
                            >
                                <Icon path={mdiClose} size={1} />
                            </IconButton>
                        ) : null}
                    </div>
                    <div className={classes.editIcon}>
                        <Icon
                            path={mdiInformation}
                            size={4}
                            color={theme.palette.blue.main}
                        />
                    </div>
                    <div className={classes.cancelTitle}>
                        {`آیتم با سریال
            "${oldInventoryItemWithSerial}"
              قبلا اضافه شده است`}
                    </div>
                </DialogTitle>
                <DialogActions>
                    <Grid container spacing={1} justify="flex-end">
                        <Grid item xs={4}>
                            <Button
                                onClick={handleCloseItemHasAlreadyAdded}
                                fullWidth
                                variant="contained"
                                size="large"
                            >
                                {'بستن'}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            <Modal
                maxWidth="sm"
                onClose={() => setOpenAddItem(false)}
                open={openAddItem}
                title={
                    <>
                        <div className={classes.addIcon}>
                            <Icon
                                path={mdiCartPlus}
                                size={4}
                                color={theme.palette.green.main}
                            />
                        </div>
                        <div style={{ margin: '10px auto', textAlign: 'center' }}>
                            اضافه کردن کالا به قبض خروج
                        </div>
                    </>
                }
                content={
                    <AddItemsParcelsForm
                        //addItem={(body: AddItemCreateParcel) => createItemsToParcels(body)}
                        getInventoryItems={(filters: any) =>
                            handleGetInventoryItems(filters)
                        }
                    />
                }
            />

            <Modal
                maxWidth="sm"
                onClose={() => setOpenAddWarehouseItem(false)}
                open={openAddWarehouseItem}
                title={
                    <>
                        <div className={classes.addIcon}>
                            <Icon
                                path={mdiCartPlus}
                                size={4}
                                color={theme.palette.green.main}
                            />
                        </div>
                        <div style={{ margin: '10px auto', textAlign: 'center' }}>
                            اضافه کردن کالا به محموله بین انبار
                        </div>
                    </>
                }
                content={
                    <AddItemsWarehouseParcelsForm
                        //addItem={(body: AddItemCreateParcel) => createItemsToParcels(body)}
                        getInventoryItems={(filters: any) =>
                            handleGetWarehouseInventoryItems(filters)
                        }
                    />
                }
            />

            <Modal
                maxWidth="xl"
                onClose={() => setOpenInventoryItemsList(false)}
                open={openInventoryItemsList}
                title={
                    <>
                        <div className={classes.addIcon}>
                            <Icon
                                path={mdiCartPlus}
                                size={4}
                                color={theme.palette.green.main}
                            />
                        </div>
                        <div style={{ margin: '10px auto', textAlign: 'center' }}>
                            لیست آیتم ها
                        </div>
                        <div style={{ margin: '5px 10px' }}>
                            <span>{'تعداد : '}</span>
                            {inventoryItemsWithFilter.length}
                        </div>
                    </>
                }
                content={
                    <>
                        <InventoryItemsList
                            addItem={(item: any) => handleAddItem(item)}
                            data={inventoryItemsWithFilter}
                        />
                        <Grid style={{ margin: '20px 0' }} container justify="flex-end">
                            <Button
                                size="large"
                                data-cy="search"
                                autoFocus
                                variant="contained"
                                color="secondary"
                                onClick={() => addToItems()}
                            >
                                افزودن به قبض
                            </Button>
                        </Grid>
                    </>
                }
            />
        </>
    );
}

export type InputsForm = {
    serial: string;
};

const BarcodeForm = (props: any) => {
    const { handleSubmit, register, setValue, getValues, watch } =
        useForm<InputsForm>();

    const onSubmit = (data: any) => {
        props.handleSubmitForm(data.serial);
    };

    useEffect(() => {
        setValue('serial', props.serialNumber);
    }, [props.serialNumber]);

    useEffect(() => {
        props.setSerialNumber(getValues().serial);
    }, [watch('serial')]);

    return (
        <form style={{ width: '320px' }} onSubmit={handleSubmit(onSubmit)}>
            <Grid
                className={props.cssClasses.detail}
                container
                spacing={2}
                alignItems="center"
            >
                <Grid item container xs={10} alignItems="flex-end">
                    <Grid item xs={2}>
                        <Icon path={mdiBarcodeScan} size={1} color="black" />
                    </Grid>
                    <Grid item xs={10}>
                        <TextField
                            fullWidth
                            id="serial"
                            name="serial"
                            size="small"
                            inputRef={register({
                                required: true,
                            })}
                            autoFocus
                            label="شماره سریال کالا را وارد کنید"
                        />
                    </Grid>
                </Grid>
                <Grid item xs={2}>
                    <IconButton
                        aria-label="details"
                        type="submit"
                        size="small"
                        title="جستجوی آیتم"
                        data-cy="details"
                    >
                        <Icon
                            path={mdiPackageVariant}
                            size={1}
                            color={theme.palette.info.main}
                        />
                    </IconButton>
                </Grid>
            </Grid>
        </form>
    );
};

export default Add;